import CheckboxGroup from './checkboxGroup';

export default CheckboxGroup;

export { type CheckboxGroupProps } from './checkboxGroup';
